import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import SEO from '../common/SEO';

// Import images for each home model
// Aurora
import auroraElevMain from '../../assets/images/Aurora/Yeremian---Aurora-A-cr (1).jpg';
import auroraElevA from '../../assets/images/Aurora/Yeremian---Aurora-A-cr (1).jpg';
import auroraElevB from '../../assets/images/Aurora/Yeremian-Aurora-B-cr (1).jpg';
import auroraElevC from '../../assets/images/Aurora/Yeremian--Aurora-C-cr (1).jpg';
import auroraFloorplan1 from '../../assets/images/Aurora/aurora 1.png';
import auroraFloorplan2 from '../../assets/images/Aurora/aurora 2.png';

// Victoria
import victoriaElevMain from '../../assets/images/Victoria/Yeremian--Victoria-A-cr.jpg';
import victoriaElevA from '../../assets/images/Victoria/Yeremian--Victoria-A-cr.jpg';
import victoriaElevB from '../../assets/images/Victoria/Yeremian--Victoria-B-cr.jpg';
import victoriaElevC from '../../assets/images/Victoria/Yeremian--Victoria-C-cr.jpg';
import victoriaFloorplan1 from '../../assets/images/Victoria/victoria 1.png';
import victoriaFloorplan2 from '../../assets/images/Victoria/victoria 2.png';

// Ceres
import ceresElevMain from '../../assets/images/Ceres/Yeremian-Ceres-A-cr (1).jpg';
import ceresElevA from '../../assets/images/Ceres/Yeremian-Ceres-A-cr (1).jpg';
import ceresElevB from '../../assets/images/Ceres/Yeremian--Ceres-B-cr (2).jpg';
import ceresElevC from '../../assets/images/Ceres/Yeremian-Ceres-C-cr (1).jpg';
import ceresFloorplan1 from '../../assets/images/Ceres/ceres 1.png';
import ceresFloorplan2 from '../../assets/images/Ceres/ceres 2.png';

// Cybele
import cybeleElevMain from '../../assets/images/Cybele/Yeremian-Cybele-A-cr (1).jpg';
import cybeleElevA from '../../assets/images/Cybele/Yeremian-Cybele-A-cr (1).jpg';
import cybeleElevB from '../../assets/images/Cybele/Yeremian-Cybele-B-cr (1).jpg';
import cybeleElevC from '../../assets/images/Cybele/Yeremian-Cybele-C-cr (1).jpg';
import cybeleFloorplan1 from '../../assets/images/Cybele/cybele 1.png';
import cybeleFloorplan2 from '../../assets/images/Cybele/cybele 2.png';

// Diana
import dianaElevMain from '../../assets/images/Diana/Yeremian-Diana-A-cr (1).jpg';
import dianaElevA from '../../assets/images/Diana/Yeremian-Diana-A-cr (1).jpg';
import dianaElevB from '../../assets/images/Diana/Yeremian--Diana-B-cr (1).jpg';
import dianaElevC from '../../assets/images/Diana/Yeremian-Diana-C-cr (1).jpg';
import dianaFloorplan1 from '../../assets/images/Diana/diana 1.png';
import dianaFloorplan2 from '../../assets/images/Diana/diana 2.png';

// Pomona
import pomonaElevMain from '../../assets/images/Pomona/Yeremian--Pomona-A-cr.jpg';
import pomonaElevA from '../../assets/images/Pomona/Yeremian--Pomona-A-cr.jpg';
import pomonaElevB from '../../assets/images/Pomona/Yeremian--Pomona-B-cr.jpg';
import pomonaElevC from '../../assets/images/Pomona/Yeremian--Pomona-C-cr.jpg';
import pomonaFloorplan1 from '../../assets/images/Pomona/pomona 1.png';
import pomonaFloorplan2 from '../../assets/images/Pomona/pomona 2.png';

// Terra
import terraElevMain from '../../assets/images/Terra/Yeremian--Terra-A-cr.jpg';
import terraElevA from '../../assets/images/Terra/Yeremian--Terra-A-cr.jpg';
import terraElevB from '../../assets/images/Terra/Yeremian-Terra-B-cr.jpg';
import terraElevC from '../../assets/images/Terra/Yeremian-Terra-C-cr.jpg';
import terraFloorplan1 from '../../assets/images/Terra/terra 1.png';
import terraFloorplan2 from '../../assets/images/Terra/terra 2.png';

// Vesta
import vestaElevMain from '../../assets/images/Vesta/Yeremian--Vesta-A-cr.jpg';
import vestaElevA from '../../assets/images/Vesta/Yeremian--Vesta-A-cr.jpg';
import vestaElevB from '../../assets/images/Vesta/Yeremian--Vesta-B-cr.jpg';
import vestaElevC from '../../assets/images/Vesta/Yeremian--Vesta-C-cr.jpg';
import vestaFloorplan1 from '../../assets/images/Vesta/vesta 1.png';
import vestaFloorplan2 from '../../assets/images/Vesta/vesta 2.png';

// This would typically come from an API or database
const homeData = {
  aurora: {
    id: 'aurora',
    name: 'Aurora',
    description: 'Our Aurora plan offers three exterior options to choose from and a two-story floor plan with 4 bedrooms and 3.5 bathrooms. The open concept main level features a spacious living room and a dining room. The upper level includes a luxurious master suite with a large walk-in closet and a private bathroom with a double vanity, a separate shower, and an optional a soaking tub. The three additional bedrooms are generously sized and offer plenty of closet space.',
    image: auroraElevMain,
    elevations: [
      auroraElevA,
      auroraElevB,
      auroraElevC,
    ],
    floorplans: [
      auroraFloorplan1,
      auroraFloorplan2
    ],
    bedrooms: 4,
    bathrooms: 3.5,
    sqft: 2800,
    garages: 2,
    stories: 2,
    features: ['Open Concept Main Level', 'Luxurious Master Suite', 'Spacious Bedrooms', 'Flex Room', 'Large Walk-in Closets', 'Double Vanity in Master Bath']
  },
  victoria: {
    id: 'victoria',
    name: 'Victoria',
    description: 'The Victoria plan features three exterior options and a spacious two-story layout with 4 bedrooms and 4 bathrooms. The main level boasts an open-concept design, including a living room, dining room, and a luxurious master suite complete with a large walk-in closet and private bathroom with double vanity, separate shower, and an optional soaking tub. The upper level houses three additional generously sized bedrooms with ample closet space.',
    image: victoriaElevMain,
    elevations: [
      victoriaElevA,
      victoriaElevB,
      victoriaElevC,
    ],
    floorplans: [
      victoriaFloorplan1,
      victoriaFloorplan2
    ],
    bedrooms: 4,
    bathrooms: 4,
    sqft: 3100,
    garages: 2,
    stories: 2,
    features: ['Open Concept Design', 'First Floor Master Suite', 'Walk-in Closets', 'Separate Shower in Master Bath', 'Optional Soaking Tub', 'Bonus Room']
  },
  ceres: {
    id: 'ceres',
    name: 'Ceres',
    description: 'The Ceres floorplan offers a stylish and practical design with versatile spaces to meet the needs of any family. The main level features a spacious office, a cozy master suite, and a versatile flex room, perfect for use as a home gym, playroom, or study. Enjoy al fresco dining and relaxation on the inviting patio, accessed from the main living area. Upstairs, two additional bedrooms provide ample space for children, guests, or a home office.',
    image: ceresElevMain,
    elevations: [
      ceresElevA,
      ceresElevB,
      ceresElevC,
    ],
    floorplans: [
      ceresFloorplan1,
      ceresFloorplan2
    ],
    bedrooms: 3,
    bathrooms: 2.5,
    sqft: 2500,
    garages: 2,
    stories: 2,
    features: ['First Floor Office', 'Flex Room', 'First Floor Master Suite', 'Inviting Patio', 'Open Floor Plan', 'Spacious Secondary Bedrooms']
  },
  cybele: {
    id: 'cybele',
    name: 'Cybele',
    description: 'The Cybele floorplan offers a unique and functional design with spacious living areas and private bedrooms. On the main level, the luxurious master suite is complemented by two additional bedrooms with a shared jack-and-jill bathroom. The second level features a huge bonus room, perfect for a home theater, game room, or additional living space. The open-concept kitchen and living room provide the perfect space for entertaining or relaxing with family.',
    image: cybeleElevMain,
    elevations: [
      cybeleElevA,
      cybeleElevB,
      cybeleElevC,
    ],
    floorplans: [
      cybeleFloorplan1,
      cybeleFloorplan2
    ],
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2900,
    garages: 2,
    stories: 2,
    features: ['First Floor Master Suite', 'Jack-and-Jill Bathroom', 'Bonus Room', 'Open Concept Kitchen', 'Spacious Living Room', 'Covered Porch']
  },
  diana: {
    id: 'diana',
    name: 'Diana',
    description: 'The Diana floorplan is a beautiful and functional two-story home with plenty of living space for families. The main level features a spacious living room and dining room, perfect for entertaining and relaxing. The well-appointed kitchen includes an island with breakfast bar and a walk-in pantry. Upstairs, find a luxurious owner\'s suite with a large walk-in closet and private bathroom, as well as three additional bedrooms and a convenient laundry room.',
    image: dianaElevMain,
    elevations: [
      dianaElevA,
      dianaElevB,
      dianaElevC,
    ],
    floorplans: [
      dianaFloorplan1,
      dianaFloorplan2
    ],
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2700,
    garages: 2,
    stories: 2,
    features: ['Spacious Living Room', 'Kitchen Island', 'Walk-in Pantry', 'Upstairs Laundry', 'Large Owner\'s Suite', 'Three Secondary Bedrooms']
  },
  pomona: {
    id: 'pomona',
    name: 'Pomona',
    description: 'The Pomona floorplan is a stunning two-story home with a spacious and functional layout. The main level features a luxurious master suite, a large great room, and a dining room, perfect for entertaining or relaxing with family. The gourmet kitchen includes an island, a walk-in pantry, and plenty of counter space. Upstairs, find three generous bedrooms, a full bathroom, and a conveniently located laundry room.',
    image: pomonaElevMain,
    elevations: [
      pomonaElevA,
      pomonaElevB,
      pomonaElevC,
    ],
    floorplans: [
      pomonaFloorplan1,
      pomonaFloorplan2
    ],
    bedrooms: 4,
    bathrooms: 3.5,
    sqft: 3000,
    garages: 2,
    stories: 2,
    features: ['First Floor Master Suite', 'Gourmet Kitchen', 'Large Great Room', 'Upstairs Laundry', 'Spacious Secondary Bedrooms', 'Flex Room']
  },
  terra: {
    id: 'terra',
    name: 'Terra',
    description: 'The Terra floorplan offers a versatile and functional design, perfect for families seeking a comfortable and spacious living space. The main level features a luxurious master suite and two additional bedrooms. The open concept living area includes a gourmet kitchen with an island, a spacious dining room, and a comfortable family room. Upstairs, a fourth bedroom and a bonus room provide additional living space for a growing family.',
    image: terraElevMain,
    elevations: [
      terraElevA,
      terraElevB,
      terraElevC,
    ],
    floorplans: [
      terraFloorplan1,
      terraFloorplan2
    ],
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2600,
    garages: 2,
    stories: 2,
    features: ['First Floor Master Suite', 'Open Concept Living', 'Gourmet Kitchen', 'Island Kitchen', 'Bonus Room', 'Covered Porch']
  },
  vesta: {
    id: 'vesta',
    name: 'Vesta',
    description: 'The Vesta floorplan is a tasteful and inviting two-story home that provides a warm and comfortable living experience. The main level features a spacious dining and family room, along with a convenient half bath. The well-appointed kitchen includes an island with breakfast bar and a walk-in pantry. Upstairs, the master suite offers a luxurious retreat with a large walk-in closet and a private bathroom with a double vanity and separate shower.',
    image: vestaElevMain,
    elevations: [
      vestaElevA,
      vestaElevB,
      vestaElevC,
    ],
    floorplans: [
      vestaFloorplan1,
      vestaFloorplan2
    ],
    bedrooms: 4,
    bathrooms: 2.5,
    sqft: 2400,
    garages: 2,
    stories: 2,
    features: ['Spacious Family Room', 'Kitchen Island', 'Walk-in Pantry', 'Luxurious Master Suite', 'Large Walk-in Closet', 'Double Vanity in Master Bath']
  }
};

// For demonstration, we'll use a fallback that points to one of our existing homes if an ID isn't found
const defaultHome = homeData.aurora;

const HomeDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const home = (id && homeData[id as keyof typeof homeData]) || defaultHome;
  
  const [activeElevation, setActiveElevation] = useState(0);

  // SEO data for this specific home
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": `${home.name} Home Plan`,
    "description": home.description,
    "brand": {
      "@type": "Brand",
      "name": "Yeremian Lifestyle Homes"
    },
    "manufacturer": {
      "@type": "Organization",
      "name": "Yeremian Lifestyle Homes"
    },
    "category": "Home Plan",
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "priceCurrency": "USD",
      "seller": {
        "@type": "Organization",
        "name": "Yeremian Lifestyle Homes"
      }
    },
    "additionalProperty": [
      {
        "@type": "PropertyValue",
        "name": "Bedrooms",
        "value": home.bedrooms
      },
      {
        "@type": "PropertyValue", 
        "name": "Bathrooms",
        "value": home.bathrooms
      },
      {
        "@type": "PropertyValue",
        "name": "Square Footage",
        "value": `${home.sqft} sqft`
      },
      {
        "@type": "PropertyValue",
        "name": "Stories",
        "value": home.stories
      }
    ]
  };

  return (
    <div>
      <SEO
        title={`${home.name} Home Plan - Yeremian Lifestyle Homes | ${home.bedrooms} Bed ${home.bathrooms} Bath ${home.sqft} sqft`}
        description={`${home.name} home plan by Yeremian Lifestyle Homes. ${home.bedrooms} bedrooms, ${home.bathrooms} bathrooms, ${home.sqft} sqft. ${home.description.substring(0, 120)}...`}
        keywords={`${home.name} home plan, ${home.bedrooms} bedroom homes Georgia, ${home.sqft} sqft homes, Yeremian Lifestyle Homes ${home.name}, custom homes Rome GA, home plans Dawsonville GA`}
        url={`https://yeremianlifestylehomes.com/homes/${home.id}`}
        type="product"
        schemaData={homeSchema}
      />
      {/* Hero Section */}
      <div className="relative h-80 md:h-96 lg:h-[500px] overflow-hidden">
        <img 
          src={home.image} 
          alt={home.name} 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-12 text-white">
          <div className="container-custom">
            <h1 className="drop-shadow-sm mb-2">The {home.name}</h1>
            <div className="flex flex-wrap gap-4 text-white/90">
              <span className="flex items-center">
                <svg className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                {home.bedrooms} Beds
              </span>
              <span className="flex items-center">
                <svg className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                </svg>
                {home.bathrooms} Baths
              </span>
              <span className="flex items-center">
                <svg className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
                {home.sqft} sqft
              </span>
              <span className="flex items-center">
                <svg className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                {home.garages} Garage
              </span>
              <span className="flex items-center">
                <svg className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                </svg>
                {home.stories} Story
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="container-custom py-12 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2">
            <h2 className="text-2xl font-serif mb-6">About the {home.name}</h2>
            <p className="text-lg text-gray-700 mb-8">{home.description}</p>
            
            <h3 className="text-xl font-serif mb-4">Featured Amenities</h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-10">
              {home.features.map((feature, index) => (
                <li key={index} className="flex items-center">
                  <svg className="h-5 w-5 text-primary mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>
            
            <h3 className="text-xl font-serif mb-4">Elevations</h3>
            <div className="mb-4">
              <img 
                src={home.elevations[activeElevation]} 
                alt={`${home.name} Elevation ${activeElevation + 1}`}
                className="w-full h-80 md:h-96 object-cover rounded-lg shadow-md"
              />
              <p className="mt-2 text-gray-600 text-center">
                {activeElevation === 0 ? 'Elevation A - Farmhouse Style' :
                 activeElevation === 1 ? 'Elevation B - Craftsman Style' :
                 'Elevation C - Traditional Style'}
              </p>
            </div>
            <div className="flex space-x-4 mb-12">
              {home.elevations.map((elevation, index) => (
                <button
                  key={index}
                  className={`w-20 h-20 rounded-md overflow-hidden border-2 transition ${
                    index === activeElevation ? 'border-primary' : 'border-transparent'
                  }`}
                  onClick={() => setActiveElevation(index)}
                  title={index === 0 ? 'Farmhouse Style' : 
                         index === 1 ? 'Craftsman Style' : 
                         'Traditional Style'}
                >
                  <img 
                    src={elevation} 
                    alt={`${index === 0 ? 'Farmhouse' : 
                           index === 1 ? 'Craftsman' : 
                           'Traditional'} Elevation`} 
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>
            
            {/* Floor Plans Section */}
            <div className="bg-gray-50 p-8 rounded-lg mb-8">
              <h3 className="text-xl font-serif mb-4">Floor Plans</h3>
              
              <div className="space-y-6">
                {home.floorplans.map((floorplan, index) => (
                  <div key={index} className="border-t border-gray-200 pt-6 first:border-0 first:pt-0">
                    <h4 className="font-medium mb-3">Level {index + 1}</h4>
                    <div className="mb-4">
                      <img 
                        src={floorplan} 
                        alt={`${home.name} Floor Plan Level ${index + 1}`}
                        className="w-full h-auto object-contain rounded-lg shadow-sm"
                      />
                    </div>
                  </div>
                ))}
                
                <p className="text-gray-700 mt-4">
                  Contact us to receive more detailed floor plans and additional information about the {home.name} home design.
                </p>
              </div>
            </div>
          </div>
          
          <div className="lg:col-span-1">
            <div className="bg-primary/5 rounded-lg p-6 shadow-sm sticky top-24">
              <h3 className="text-xl font-serif mb-4">Interested in the {home.name}?</h3>
              <p className="text-gray-700 mb-6">
                Contact us today to learn more about building your dream home with the {home.name} plan.
              </p>
              <Link to="/contact" className="btn btn-primary w-full mb-3">Contact Us</Link>
              <Link to="/neighborhoods" className="btn btn-outline w-full mb-6">Find a Neighborhood</Link>
              
              <div className="border-t border-gray-200 pt-6 mt-6">
                <h4 className="font-medium mb-3">Home Details</h4>
                <ul className="space-y-3">
                  <li className="flex justify-between">
                    <span className="text-gray-600">Bedrooms:</span>
                    <span className="font-medium">{home.bedrooms}</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-600">Bathrooms:</span>
                    <span className="font-medium">{home.bathrooms}</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-600">Square Footage:</span>
                    <span className="font-medium">{home.sqft} sqft</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-600">Garage:</span>
                    <span className="font-medium">{home.garages} Car</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="text-gray-600">Stories:</span>
                    <span className="font-medium">{home.stories}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeDetail; 